import React, {useEffect} from 'react';
import appStore from '../../storage/AppStore'
import adminStore from '../../storage/AdminStore'
import {Link} from 'react-router'
import {observer} from "mobx-react-lite";
import {BsPencil, BsPlus, BsSearch} from "react-icons/bs";
import {useTelegram} from "../../hooks/useTelegram";
import Btn from "../../ui/Btn";
import CompaniesSearch from "./CompaniesSearch";

const AdminCompanies = () => {
    const {tg, isValid} = useTelegram()

    useEffect(() => {
        if (appStore.user?.is_admin) {
            adminStore.searchCompanies()
        }
    }, [appStore.user])

    return (
        <main className={'mt-2 mb-3'}>
            <CompaniesSearch/>
            {adminStore.companies_query.count} компания {adminStore.companies.length === 0 ? <Link to={`/admin/new_company`}><BsPlus/></Link> : ''}
            {adminStore.companies?.length > 0 &&
                <table>
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Аты</th>
                        <th>Спорт</th>
                        <th><Link size={'sm'} variant={'success'}
                                        to={`/admin/new_company`}><BsPlus/></Link></th>
                    </tr>
                    </thead>
                    <tbody>
                    {adminStore.companies?.map(c => (
                        <tr key={c.id}>
                            <td>{c.id}</td>
                            <td>{c.name}</td>
                            <td>{c.sports.map(s => s.icon + " " + s.name).join(', ')}</td>
                            <td><Link size={'sm'} variant={'primary'}
                                        to={`/admin/edit_company/${c.id}`}><BsPencil/></Link></td>
                        </tr>
                    ))}
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colSpan={4}>
                            <div className={'d-flex justify-content-center'}>
                                <div>
                                    {adminStore.companies_query.page_number > 1 &&
                                        <div>
                                            <Btn variant={'secondary'} size={'sm'}
                                                    onClick={() => {
                                                        adminStore.companies_query.setProperty('page_number', adminStore.companies_query.page_number - 1);
                                                        adminStore.searchCompanies();
                                                    }}>
                                                {'<'}
                                            </Btn>
                                        </div>
                                    }
                                    <div>{adminStore.companies_query.page_number}/{adminStore.companies_query.page_count}</div>
                                    {adminStore.companies_query.page_number < adminStore.companies_query.page_count &&
                                        <div>
                                            <Btn variant={'secondary'} size={'sm'}
                                                    onClick={() => {
                                                        adminStore.companies_query.setProperty('page_number', adminStore.companies_query.page_number + 1);
                                                        adminStore.searchCompanies();
                                                    }}>
                                                {'>'}
                                            </Btn>
                                        </div>
                                    }
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            }
        </main>
    );
};

export default observer(AdminCompanies);